import {  Card, CardContent, Divider, makeStyles, Typography } from '@material-ui/core';
import { Button } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';

const useStyles = makeStyles({
  button: 
  {
    borderRadius: '10px', 
    color: '#154773',
    textDecoration: 'none',
    fontSize: '14px',
    display: 'block',
    margin: '10px', 
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  view: {
    padding: "6px 12px",
    border: "1px solid #122b40",
    color: "#fff",
    backgroundColor:" #012951",
    borderRadius: '4px'
  },
})


const PrivateProfessionals = () => {
  const homeUrl = '/digit-ui/citizen'
  const classes = useStyles()
  return (
    <Card style={{maxWidth: 'fit-content', margin: '10px', boxShadow: 'rgba(6, 24, 44, 0.4) 0px 0px 0px 2px, rgba(6, 24, 44, 0.65) 0px 4px 6px -1px, rgba(255, 255, 255, 0.08) 0px 1px 0px inset'}}>
      <CardContent>
        <Typography variant="h6" style={{ backgroundColor: '#1F4A7C',color: "#fff", padding: "10px", fontSize: '15px' }}>
            Online Services
        </Typography>
        
        <Link to={`${homeUrl}/obps/services/registration`}>
          <p variant="body1" component="p" className={classes.button}>
            Apply for Architect Registration
          </p>
        </Link>
        <Divider />
        
        {/* <Link to={`${homeUrl}/obps/services/registration`}>
          <p variant="body1" component="p" className={classes.button}>
            Apply for Registration / Empanelment of Structural Engineers (With 6 years experience)
          </p>
        </Link> */}
        
        {/* <Divider /> */}
        {/* <Link to={`${homeUrl}/InProgreeService`}>
        <p variant="body1" component="p" className={classes.button}>
        Apply for permission of Development of land and Proposed/ existing building construction  <strong>E-Map Center</strong>
        </p>
        </Link> */}
        {/* <Divider />
        <Link to={`${homeUrl}/obps/services/form11`}>
        <p variant="body1" component="p"  className={classes.button}>
        Apply for  permission of  sub-division/Development  of land <strong>Form - 11</strong>
        </p>
        </Link> */}
        {/* <Divider /> */}
        <Link to={`${homeUrl}/obps/edcrscrutiny/apply/home`}>
        <p variant="body1" component="p" className={classes.button}>
        {/* <a variant="body1" href='/digit-ui/citizen/form12' component="p" className={classes.button}> */}
        Apply for <strong>Map Submission</strong>
        </p>
        </Link>
        {/* <Divider />
        <Link to={`${homeUrl}/obps/services/form16`}>
        <p variant="body1" component="p" className={classes.button}>
        Apply for appeal   <strong>Form - 16</strong>
        </p>
        </Link> */}
        {/* <Divider />
        <Link to={`${homeUrl}/obps/services/form16`}>
        <p variant="body1" component="p" className={classes.button}>
        Apply for composition of offences  to extent  of  permissible limit of 10%  <strong>Form - 26</strong>
        </p>
        </Link>
        <Divider /> */}
        <div style={{display: 'flex', justifyContent: 'right'}}>
        <Link to='obps/services/registration'>
          <Button className={classes.view} style={{padding: '6px 12px', backgroundColor: '#012951', color: 'white', border: '1px solid #122b40', marginRight: '20px' }}>Sign Up</Button>
        </Link>
        <Link to="profile">
          <Button className={classes.view} style={{padding: '6px 12px', backgroundColor: '#012951', color: 'white', border: '1px solid #122b40'}}>Sign In</Button>
        </Link>
        </div>
      </CardContent>
    </Card>
  );
};

export default PrivateProfessionals